// ListeVenteModifier.js
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './ListeVenteModifier.css';
import api from '../../api';

function ListeVenteModifier() {
  const [ventes, setVentes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const navigate = useNavigate();

  const fetchVentes = async () => {
    try {
      const res = await api.get('/sales', {
        params: {
          page: page,
          limit: 10
        }
      });

      setVentes(res.data.sales || []);
      setTotalPages(res.data.totalPages || 1);
      setLoading(false);
    } catch (err) {
      console.error('Erreur de chargement des ventes:', err);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchVentes();
  }, [page]);

  const handleClick = (id) => {
    navigate(`/modifier-vente/${id}`);
  };

  const renderPagination = () => {
    if (totalPages <= 1) return null;

    const pages = [];
    for (let i = 1; i <= totalPages; i++) {
      pages.push(
        <button
          key={i}
          onClick={() => setPage(i)}
          disabled={i === page}
          className={`pagination-number ${i === page ? 'active' : ''}`}
        >
          {i}
        </button>
      );
    }

    return (
      <div className="pagination-container">
        <button onClick={() => setPage(1)} disabled={page === 1} className="pagination-btn">&#171;</button>
        <button onClick={() => setPage(page - 1)} disabled={page === 1} className="pagination-btn">&#8249;</button>
        {pages}
        <button onClick={() => setPage(page + 1)} disabled={page === totalPages} className="pagination-btn">&#8250;</button>
        <button onClick={() => setPage(totalPages)} disabled={page === totalPages} className="pagination-btn">&#187;</button>
      </div>
    );
  };

  return (
    <div className="liste-vente-modifier-container">
      <h2>Modifier une Vente</h2>
      {loading ? (
        <p>Chargement des ventes...</p>
      ) : (
        <>
          <ul className="vente-liste">
            {ventes.map((vente) => (
              <li key={vente._id} className="vente-item" onClick={() => handleClick(vente._id)}>
                <div className="vente-content">
                  <span className="vente-titre">{vente.title}</span>
                  <span className="vente-cat">{vente.category}</span>
                  <span className="vente-reference">{vente.details.reference}</span>
                  <span className="vente-prix">{vente.details.price} XOF</span>
                </div>
              </li>
            ))}
          </ul>
          {renderPagination()}
        </>
      )}
    </div>
  );
}

export default ListeVenteModifier;
